import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { DEFAULT_LOCALE } from '../shared/constants/common.constant';
import { GraphqlModule } from './graphql/graphql.module';
import { LazyTranslateLoader } from './services/translation/lazy-translate-loader';
import { TranslationService } from './services/translation/translation.service';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
export class CoreModule {
}
CoreModule.ɵfac = function CoreModule_Factory(t) { return new (t || CoreModule)(); };
CoreModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CoreModule });
CoreModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [TranslationService], imports: [[
            CommonModule,
            HttpClientModule,
            GraphqlModule,
            TranslateModule.forRoot({
                defaultLanguage: DEFAULT_LOCALE,
                loader: {
                    provide: TranslateLoader,
                    useClass: LazyTranslateLoader,
                    deps: [HttpClient],
                },
            }),
        ], TranslateModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CoreModule, { imports: [CommonModule,
        HttpClientModule,
        GraphqlModule, i1.TranslateModule], exports: [TranslateModule] }); })();
